// extracted by mini-css-extract-plugin
export var linkHighlight = "Footer-module--link-highlight--3i4j5";
export var footer = "Footer-module--footer--3h9FW";
export var footerTop = "Footer-module--footer-top--2AV7j";
export var footerList = "Footer-module--footer-list--399Wz";
export var copyright = "Footer-module--copyright--baNeO";
export var copyrightList = "Footer-module--copyright-list--3f5-T";
export var copyrightListItem = "Footer-module--copyright-list-item--1z8pz";
export var copyrightListLight = "Footer-module--copyright-list-light--1-QHO";
export var socialList = "Footer-module--social-list--t47Wg";
export var globalLinks = "Footer-module--global-links--1zPMa";